import { Directive } from '@angular/core';

@Directive({
    selector: '[apxPrefix]',
    standalone: true
})
export class ApxPrefixDirective {}
